<template>
    <div class="query">
<!--        <div class="title">-->
<!--            <p class="return" @click="back">-->
<!--                <img src="~@public/img/user/login/jian.png"/>-->
<!--            </p>-->
<!--            出入境证件办理进度查询-->
<!--        </div>-->
        <van-cell-group>
            <van-field v-model="workNum" clearable label="业务编号:" placeholder="请输入业务编号"/>
            <!--<verification-code-input @setVerificationCode="getVerificationCode"
                                     ref="childFunction"></verification-code-input>-->
            <Vue2Verify ref="verify" v-if="show" @closeClick="show = false" @success='success'
                        :imgSize="{width:'310px',height:'155px'}"></Vue2Verify>
        </van-cell-group>
        <div class="btn-submit-div">
            <van-button type="info" size="large" @click="submit">查询</van-button>
        </div>
        <div class="boxList" v-for="(item, index) in dataList" :key="index" v-if="listShow">
            <div class="boxList-item">
                <span>业务编号:</span>
                <span>{{item.ywbh}}</span>
            </div>
            <div class="boxList-item">
                <span>姓名:</span>
                <span>{{item.xm}}</span>
            </div>
            <div class="boxList-item">
                <span>证件种类:</span>
                <span>{{item.zjzl}}</span>
            </div>
            <div class="boxList-item">
                <span>受理日期:</span>
                <span>{{item.slrq}}</span>
            </div>
            <div class="boxList-item">
                <span>办理状态:</span>
                <span>{{item.bzjd_text}}</span>
            </div>
        </div>
    </div>
</template>

<script>

    import {CellGroup, Field, Toast, Button, Popup, Picker} from 'vant'
    import VerificationCodeInput from "@/components/verification-code-input/VerificationCodeInput";
    import { idCardType } from '@/api/crj-dict/index'
    import {queryApiMap} from "@/api/query";
    import { getNormalDate } from '@/views/user/electronicCertificate/utils/birthday'
    import Vue2Verify from "@/views/signUp/verify/verify"

    export default {
        name: "Entry-exit",
        components: {
            Vue2Verify,
            VerificationCodeInput,
            [CellGroup.name]: CellGroup,
            [Field.name]: Field,
            [Toast.name]: Toast,
            [Button.name]: Button,
            [Popup.name]: Popup,
            [Picker.name]: Picker
        },
        data() {
            return {
                show: false,
                handlingId: '', // 身份证号
                receiveVerificationCode: {}, // 接收验证码子组件传来verificationInfo对象
                listShow: false,
                workNum: '', // 业务编号
                idTypeMap: {},
                showPeopleType: false,
                dataList: []
            }
        },
        mounted() {
            this.initIdTypeMap()
            this.logger.visit('106','0')
        },
        methods: {
            // 初始化证件类型
            initIdTypeMap() {
                idCardType.forEach(obj=>{
                    this.idTypeMap[obj.id] = obj.name
                })
            },
            // // 选择人员类别
            // onConfirmPeopleType(value) {
            //     this.peopleTypeName = value.name
            //     this.peopleTypeValue = value.id
            //     this.showPeopleType = false
            // },
            /**
             * 接收验证码输入框组件传来的verificationInfo对象
             * @param value 验证码输入框verificationInfo对象
             */
            getVerificationCode(value) {
                this.receiveVerificationCode = value
            },

          submit() {
            if(!this.workNum) {
              Toast('请输入业务编号')
            } else {
              this.show=true
            }
          },

          async success(val) {
            Toast.loading({
              duration: 0,       // 持续展示 toast
              forbidClick: true, // 禁用背景点击
              loadingType: 'spinner',
              message: '查询中...'
            })
            try {
              const data = {
                taskNum: this.workNum.toUpperCase(),
                genGuid: val.captchaVerification,
                validCode: val.captchaVerification
              }
              const res = await this.$httpUtils.postCommonUtils(`${queryApiMap.queryCrjProgress}`, data)
              this.show = false
              //关闭加载
              Toast.clear()
              if (res.data.succ) {
                const data = Object.assign([], res.data.data)
                console.log(data)
                data.forEach(obj=>{
                  if(obj.slrq) {
                    obj.slrq = getNormalDate(obj.slrq)
                  }
                  obj.zjzl = this.idTypeMap[obj.zjzl]
                })
                this.dataList = data
                this.listShow = true
              } else {
                Toast.fail('查询失败，暂无数据')
              }
            } catch (error) {
              Toast.fail('服务器运行失败，请稍后再试。')
              console.log(error)
            }
          },

            /**
             * 点击查询
             */
            async query() {
                if(!this.workNum) {
                    Toast('请输入业务编号')
                } else if (!this.receiveVerificationCode.verificationIsNoneStatus) {
                    Toast('请输入验证码')
                } else if (!this.receiveVerificationCode.verificationSuccessStatus) {
                    Toast('请输入正确的验证码')
                } else {
                    Toast.loading({
                        duration: 0,       // 持续展示 toast
                        forbidClick: true, // 禁用背景点击
                        loadingType: 'spinner',
                        message: '查询中...'
                    })
                    try {
                        const data = {
                            taskNum: this.workNum.toUpperCase(),
                            genGuid: this.receiveVerificationCode.verificationCodeGuid,
                            validCode: this.receiveVerificationCode.verificationCode
                        }
                        const res = await this.$httpUtils.postCommonUtils(`${queryApiMap.queryCrjProgress}`, data)
                        if (res.data.succ) {
                            const data = Object.assign([], res.data.data)
                            console.log(data)
                            data.forEach(obj=>{
                                if(obj.slrq) {
                                    obj.slrq = getNormalDate(obj.slrq)
                                }
                                obj.zjzl = this.idTypeMap[obj.zjzl]
                            })
                            this.dataList = data
                            this.listShow = true
                            Toast.clear()
                        } else {
                            Toast.fail('查询失败，暂无数据')
                            this.$refs.childFunction.interactionVerificationCode()
                        }
                    } catch (error) {
                        Toast.fail('服务器运行失败，请稍后再试。')
                        console.log(error)
                    }
                }
            },
            back() {
                this.$router.go(-1);
            }
        }
    }
</script>

<style scoped>

</style>
<style>
    @import "~@assets/css/public/Common.css";
</style>
